import memberBookingsTable from './member_bookings_table.html';
import editBookingModalForm from '../_templates/edit_booking_modal_form.html';
import bookingsTableCancelBookingTemplate from '../../core/_templates/bookings_table_cancel_booking.html';

function MemberBookingsTableCtrl($scope, $uibModal, $log, $translate, ModalForm, BBModel) {
    'ngInject';

    $scope.loading = true;

    if (!$scope.fields) {
        $scope.fields = ['date_order', 'details'];
    }

    $scope.$watch('member', (member) => {
        if (member != null) {
            return getBookings($scope, member);
        }
    });

    $scope.edit = function (id) {
        const booking = _.find($scope.booking_models, b => b.id === id);
        return booking.$getAnswers().then((answers) => {
            for (const answer of Array.from(answers.answers)) {
                booking[`question${answer.question_id}`] = answer.value;
            }
            return ModalForm.edit({
                model: booking,
                title: $translate.instant('MEMBER.MODAL.EDIT_BOOKING.TITLE'),
                templateUrl: editBookingModalForm.id,
                success(b) {
                    b = new BBModel.Member.Booking(b);
                    const i = _.indexOf($scope.booking_models, b => b.id === id);
                    $scope.booking_models[i] = b;
                    return $scope.setRows();
                }
            });
        });
    };

    $scope.cancel = function (id) {
        const booking = _.find($scope.booking_models, b => b.id === id);

        const modalInstance = $uibModal.open({
            templateUrl: bookingsTableCancelBookingTemplate.id,
            controller($scope, $uibModalInstance, booking) {
                $scope.booking = booking;
                $scope.booking.notify = true;
                $scope.ok = () => $uibModalInstance.close($scope.booking);
                return $scope.close = () => $uibModalInstance.dismiss();
            },
            scope: $scope,
            resolve: {
                booking() {
                    return booking;
                }
            }
        });

        return modalInstance.result.then((booking) => {
            $scope.loading = true;
            const params =
                {notify: booking.notify};
            return booking.$post('cancel', params).then(() => {
                const i = _.findIndex($scope.booking_models, b => b.id === booking.id);
                $scope.booking_models.splice(i, 1);
                $scope.setRows();
                return $scope.loading = false;
            });
        });
    };

    $scope.setRows = () =>
        $scope.bookings = _.map($scope.booking_models, (booking) => {
                return {
                    id: booking.id,
                    date: moment(booking.datetime).format('YYYY-MM-DD'),
                    date_order: moment(booking.datetime).format('x'),
                    datetime: moment(booking.datetime),
                    details: booking.full_describe,
                    status: booking.status
                };
            }
        )
    ;

    const getBookings = function ($scope, member) {
        const params = {
            src: member,
            start_date: $scope.startDate.format('YYYY-MM-DD'),
            start_time: $scope.startTime ? $scope.startTime.format('HH:mm') : undefined,
            end_date: $scope.endDate ? $scope.endDate.format('YYYY-MM-DD') : undefined,
            end_time: $scope.endTime ? $scope.endTime.format('HH:mm') : undefined
        };
        return BBModel.Member.Booking.$query(member, params).then((bookings) => {
                const now = moment.unix();
                if ($scope.period && ($scope.period === 'past')) {
                    $scope.booking_models = _.filter(bookings.items, x => x.datetime.unix() < now);
                }
                if ($scope.period && ($scope.period === 'future')) {
                    $scope.booking_models = _.filter(bookings.items, x => x.datetime.unix() > now);
                } else {
                    $scope.booking_models = bookings.items;
                }

                $scope.setRows();
                return $scope.loading = false;
            }
            , (err) => {
                $log.error(err.data);
                return $scope.loading = false;
            });
    };

    if (!$scope.startDate) {
        $scope.startDate = moment();
    }

    $scope.orderBy = $scope.defaultOrder;
    if ($scope.orderBy == null) {
        $scope.orderBy = 'date_order';
    }

    $scope.now = moment();

    if ($scope.member) {
        return getBookings($scope, $scope.member);
    }
}

function MemberBookingsTableDirective() {
    'ngInject';

    return {
        controller: MemberBookingsTableCtrl,
        templateUrl: memberBookingsTable.id,
        scope: {
            apiUrl: '@',
            fields: '=?',
            member: '=',
            startDate: '=?',
            startTime: '=?',
            endDate: '=?',
            endTime: '=?',
            defaultOrder: '=?',
            period: '=?'
        }
    };
}

angular
    .module('BBMember')
    .directive('memberBookingsTable', MemberBookingsTableDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/member-bookings-table/member_bookings_table.directive.js